import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { Label as RAC_Label } from 'react-aria-components';
import styles from './Label.module.css';
import type { LabelProps } from './Label.types';
const Label = t0 => {
  const $ = _c(14);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isDisabled: t1,
      isRequired: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const isDisabled = t1 === undefined ? false : t1;
  const isRequired = t2 === undefined ? false : t2;
  let t3;
  if ($[4] !== isDisabled) {
    t3 = clsx(styles.label, {
      [styles.disabled]: isDisabled
    });
    $[4] = isDisabled;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const labelStyles = t3;
  let t4;
  if ($[6] !== labelStyles || $[7] !== props) {
    t4 = <RAC_Label {...props} data-test-id="Label" className={labelStyles} />;
    $[6] = labelStyles;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isRequired) {
    t5 = isRequired && <span className={styles.required} aria-hidden="true">{" *"}</span>;
    $[9] = isRequired;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export { Label };